/**
 * Created by XuQiang on 2017/5/23.
 */
import React from 'react';
import ReservationCarouser from './ReservationCarouser';
import ReservationBottomSection from './ReservationBottomSection';
import Header from './Header';
import OpenDialogDiv from './OpenDialogDiv';

export default ({ intl, dispatch, loginData, menuData, locale }) => {
  let hostUrl = String(window.location.host).toLowerCase();
  return (
    <div>
      <section>
        <div className="main-cont">
          <Header
            intl={intl}
            dispatch={dispatch}
            menuData={menuData}
            locale={locale}
            flag="index"
          />
        </div>
        <div className="banner-cont">
          <ReservationCarouser />
          <OpenDialogDiv
            intl={intl}
            dispatch={dispatch}
            menuData={menuData}
            loginData={loginData}
            locale={locale}
          />
        </div>
        {hostUrl.indexOf('wafer') > -1 || hostUrl.indexOf('virsical') > -1 ? (
          <ReservationBottomSection />
        ) : null}
      </section>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/login/LoginIndex.js